import { useMemo } from 'react';
import { useGetUserCountByState } from '@practium/features/api';

export interface RegionData {
	name: string;
	value: number;
	percentage: number;
	color: string;
}

const COLORS = ['#689ee6', '#8B9FE8', '#A89FEA'];

export const useRegionPieChart = () => {
	const southeast = useGetUserCountByState('ES,MG,RJ,SP');
	const midwest = useGetUserCountByState('DF,GO,MT,MS');
	const northeast = useGetUserCountByState('AL,BA,CE,MA,PB,PE,PI,RN,SE');

	const chartData = useMemo((): RegionData[] => {
		const regions = [
			{ name: 'Sudeste', value: southeast.data?.totalUsers ?? 0 },
			{ name: 'Centro-Oeste', value: midwest.data?.totalUsers ?? 0 },
			{ name: 'Nordeste', value: northeast.data?.totalUsers ?? 0 },
		];
		const total = regions.reduce((sum, region) => sum + region.value, 0);

		return regions
			.filter((region) => region.value > 0)
			.sort((a, b) => b.value - a.value)
			.map((region, index) => ({
				...region,
				percentage: total > 0 ? Math.round((region.value / total) * 100) : 0,
				color: COLORS[index],
			}));
	}, [southeast.data, midwest.data, northeast.data]);

	return {
		chartData,
		isLoading: southeast.isPending || midwest.isPending || northeast.isPending,
		isError: southeast.isError || midwest.isError || northeast.isError,
	};
};
